(function () {
  "use strict";

  var SETTINGS = window.RETAIL_ANALYTICS || {};
  if (SETTINGS.enabled !== true || window.__sonicLambRetailAnalytics) return;
  window.__sonicLambRetailAnalytics = true;

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  var APP_VERSION       = "retail_v2";
  var EXPERIENCE        = "retail_qr";
  var CLARITY_PROJECT   = "izsv8i9q9z";
  var SUMMARY_INTERVAL  = 30000;   // ms between periodic session summaries
  var CLARITY_RETRY_MS  = 2000;    // ms to wait before retrying Clarity tag
  var SCROLL_MILESTONES = [25, 50, 75, 100];
  var ATTRIBUTION_KEY = "retail_attribution_v2";
  var VISIT_KEY = "retail_visit_v2";
  var ATTRIBUTION_DAYS = Number(SETTINGS.attributionDays) || 30;
  if (ATTRIBUTION_DAYS < 1 || ATTRIBUTION_DAYS > 365) ATTRIBUTION_DAYS = 30;
  var ATTRIBUTION_TTL = ATTRIBUTION_DAYS * 86400000;
  var ATTRIBUTION_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  var pendingGA4 = [];
  var deliveryTimer = null;
  var validationReady = false;
  var started = false;

  // ─── STATE ─────────────────────────────────────────────────────────────────
  var s = {
    // Identity
    scan_id:          null,
    device_id:        null,
    scan_start_ts:    null,
    scan_start_ms:    Date.now(),
    is_new_scan_24h:  false,

    // Store & Campaign Attribution
    store_id:         null,
    utm_source:       null,
    utm_medium:       null,
    utm_campaign:     null,
    utm_content:      null,
    utm_term:         null,
    attribution_source: "unknown",
    attribution_age_days: 0,
    store_validation: "not_provided",
    qr_visit_id: "",
    qr_visit_time_ist: "",
    retail_visit_type: "untagged",
    is_new_qr_visit: false,

    // Screens
    current_screen:   null,
    screen_enter_ms:  null,
    screens_reached:  [],

    // Demo modes
    current_mode_id:    null,
    current_mode_name:  null,
    mode_enter_ms:      null,
    mode_sequence:      0,
    modes_tried:        [],
    user_selected_modes: [],
    mode_had_play:      false,
    mode_play_count:    0,

    // Tracks
    tracks_played:        {},   // track_id -> count in this scan
    current_track_id:     null,
    track_play_start_ms:  null,
    plays_in_scan:        0,
    first_track_id:       null,
    first_mode_id:        null,
    current_playback_id: "",
    playback_state: "idle",

    // Aggregates
    player_reached:   false,
    song_played:      false,
    max_scroll:       0,
    scroll_fired:     {},       // screen -> { 25: true, ... }

    // Internals
    summary_timer:    null,
    clarity_ready:    false
  };

  // ─── IDENTITY ──────────────────────────────────────────────────────────────

  function pad(n) { return String(n).padStart ? String(n).padStart(2, "0") : (n < 10 ? "0" + n : String(n)); }

  function makeId(prefix) {
    var d = new Date();
    var date = d.getFullYear() + "" + pad(d.getMonth() + 1) + "" + pad(d.getDate());
    var time = pad(d.getHours()) + "" + pad(d.getMinutes()) + "" + pad(d.getSeconds());
    var rand = Math.random().toString(36).substr(2, 6);
    return prefix + "_" + date + "_" + time + "_" + rand;
  }

  function makeDeviceId() {
    return "dev_" + Math.random().toString(36).substr(2, 8);
  }

  function initIdentity() {
    s.scan_id = storageGet("sessionStorage", "retail_scan_id") || makeId("scan");
    s.device_id = storageGet("localStorage", "retail_device_id") || makeDeviceId();
    s.scan_start_ts = storageGet("sessionStorage", "retail_scan_start_ts") || new Date().toISOString();
    var lastTs = Number(storageGet("localStorage", "retail_last_scan_ts"));
    s.is_new_scan_24h = !lastTs || Date.now() - lastTs > 86400000;
    storageSet("sessionStorage", "retail_scan_id", s.scan_id);
    storageSet("localStorage", "retail_device_id", s.device_id);
    storageSet("sessionStorage", "retail_scan_start_ts", s.scan_start_ts);
    storageSet("localStorage", "retail_last_scan_ts", String(Date.now()));
  }

  function initAttribution() {
    var params = new URLSearchParams(window.location.search);
    var rawStore = params.get("store_id") || params.get("store") || params.get("retail_store") || "";
    var campaign = cleanValue(params.get("utm_campaign"));
    if (!rawStore && campaign.indexOf("store_") === 0) rawStore = campaign.slice(6);
    var tagged = !!rawStore || ATTRIBUTION_FIELDS.some(function (key) { return params.has(key); });
    var record = null;
    var now = Date.now();
    if (tagged) {
      record = { version: 2, store_id: validStoreId(rawStore) ? rawStore : "", captured_at: now, expires_at: now + ATTRIBUTION_TTL };
      ATTRIBUTION_FIELDS.forEach(function (key) { record[key] = cleanValue(params.get(key)); });
      var previousTouch = readAttribution("sessionStorage");
      if ((navigationType() === "reload" || navigationType() === "back_forward") && previousTouch &&
          previousTouch.store_id === record.store_id && ATTRIBUTION_FIELDS.every(function (key) { return previousTouch[key] === record[key]; })) {
        record = previousTouch; // A refresh is not a new marketing touch or TTL.
      }
      s.attribution_source = "url";
      // Store the complete touch together, including blank fields. Never mix stores.
      ["sessionStorage", "localStorage"].forEach(function (kind) {
        storageSet(kind, ATTRIBUTION_KEY, JSON.stringify(record));
        storageSet(kind, "retail_store_id", record.store_id);
        ATTRIBUTION_FIELDS.forEach(function (key) { storageSet(kind, "retail_" + key, record[key]); });
      });
    } else {
      record = readAttribution("sessionStorage");
      s.attribution_source = record ? "session" : "unknown";
      if (!record) {
        record = readAttribution("localStorage");
        if (record) s.attribution_source = "persisted";
      }
      // Legacy keys have no capture date. Retain them, but do not invent a new TTL.
    }
    s.store_id = record ? record.store_id : "";
    ATTRIBUTION_FIELDS.forEach(function (key) { s[key] = record ? record[key] : ""; });
    s.attribution_age_days = record ? Math.floor((now - record.captured_at) / 86400000) : 0;
    s.store_validation = rawStore && !validStoreId(rawStore) ? "invalid" : (s.store_id ? "pending" : "not_provided");
    initVisit(params, tagged, rawStore);
  }

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.analyticsProcessingAllowed !== "function" || privacy.analyticsProcessingAllowed();
    } catch (e) { return false; }
  }

  function storageGet(kind, key) {
    try { return analyticsAllowed() ? window[kind].getItem(key) : null; } catch (e) { return null; }
  }

  function storageSet(kind, key, value) {
    try { if (analyticsAllowed()) window[kind].setItem(key, value); } catch (e) {}
  }

  function cleanValue(value) {
    return typeof value === "string" ? value.replace(/[\u0000-\u001f\u007f]/g, "").slice(0, 100) : "";
  }

  function validStoreId(value) {
    return typeof value === "string" && /^[a-z0-9][a-z0-9_-]{0,99}$/.test(value);
  }

  function readAttribution(kind) {
    try {
      var record = JSON.parse(storageGet(kind, ATTRIBUTION_KEY));
      if (!record || record.version !== 2 || !Number.isFinite(record.captured_at) ||
          !Number.isFinite(record.expires_at) || record.captured_at > Date.now() ||
          record.expires_at <= Date.now() || record.expires_at <= record.captured_at ||
          Date.now() - record.captured_at >= ATTRIBUTION_TTL ||
          (record.store_id !== "" && !validStoreId(record.store_id))) return null;
      ATTRIBUTION_FIELDS.forEach(function (key) { record[key] = cleanValue(record[key]); });
      return record;
    } catch (e) { return null; }
  }

  function navigationType() {
    var navigation = "navigate";
    try {
      var entries = window.performance.getEntriesByType("navigation");
      if (entries.length) navigation = entries[0].type;
    } catch (e) {}
    return navigation;
  }

  function initVisit(params, tagged, rawStore) {
    var navigation = navigationType();
    var key = JSON.stringify([window.location.pathname, cleanValue(rawStore)].concat(ATTRIBUTION_FIELDS.map(function (field) { return cleanValue(params.get(field)); })));
    var previous = null;
    try { previous = JSON.parse(storageGet("sessionStorage", VISIT_KEY)); } catch (e) {}
    var continuation = (navigation === "reload" || navigation === "back_forward") && previous && previous.key === key &&
      typeof previous.id === "string" && previous.id.length <= 100 && Number.isFinite(previous.at) && previous.at <= Date.now() &&
      typeof previous.is_qr === "boolean" && Date.now() - previous.at < ATTRIBUTION_TTL;
    var isQr = !!rawStore || /^(qr|qr_code|qrcode)$/i.test(params.get("utm_medium") || "");
    var visit = continuation ? previous : { id: makeId("visit"), key: key, at: Date.now(), is_qr: isQr };
    // IST is UTC+05:30. Derive a display value without changing the epoch used
    // for expiry/deduplication, including when upgrading an existing visit.
    visit.qr_visit_time_ist = visit.is_qr ? formatIstTimestamp(visit.at) : "";
    s.qr_visit_id = visit.is_qr ? visit.id : "";
    s.qr_visit_time_ist = visit.qr_visit_time_ist;
    s.is_new_qr_visit = !!(isQr && !continuation);
    s.retail_visit_type = continuation ? (navigation === "reload" ? "reload" : "history_return") :
      (isQr ? "qr_tagged" : (s.attribution_source === "persisted" || s.attribution_source === "session" ? "direct_return" : (tagged ? "campaign_tagged" : "untagged")));
    storageSet("sessionStorage", VISIT_KEY, JSON.stringify(visit));
  }

  function formatIstTimestamp(epochMs) {
    return new Date(epochMs + 330 * 60000).toISOString().replace(/Z$/, "+05:30");
  }

  function reportedStoreId() {
    if (s.store_validation === "verified") return s.store_id;
    return s.store_id && (s.store_validation === "pending" || s.store_validation === "unverified") ? "unverified_store" : "direct_or_unknown";
  }

  function validateStore() {
    if (!s.store_id) { validationReady = true; flushGA4(); return; }
    var settled = false;
    function finish(ids) {
      var previous = s.store_validation;
      s.store_validation = ids ? (ids.indexOf(s.store_id) !== -1 ? "verified" : "invalid") : "unverified";
      validationReady = true;
      // Queued events belong to this page's immutable attribution touch.
      pendingGA4.forEach(function (entry) {
        entry.params.store_id = reportedStoreId();
        entry.params.store_validation = s.store_validation;
      });
      flushGA4();
      tagClaritySession();
      if (settled && previous !== s.store_validation) sendGA4("retail_attribution_validation", { reported_store_id: s.store_id });
      settled = true;
    }
    var timeout = window.setTimeout(function () { if (!settled) finish(null); }, 1500);
    if (!SETTINGS.storeDataPath || typeof window.fetch !== "function") { finish(null); window.clearTimeout(timeout); return; }
    Promise.resolve().then(function () { return window.fetch(SETTINGS.storeDataPath); }).then(function (response) {
      if (!response.ok) throw new Error("Store directory unavailable");
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.cities)) throw new Error("Invalid store directory");
      var ids = [];
      data.cities.forEach(function (city) {
        (city.stores || []).forEach(function (store) { if (validStoreId(store.id)) ids.push(store.id); });
      });
      if (!ids.length) throw new Error("Empty store directory");
      window.clearTimeout(timeout);
      finish(ids);
    }).catch(function () { window.clearTimeout(timeout); if (!settled) finish(null); });
  }

  // ─── GA4 HELPERS ───────────────────────────────────────────────────────────

  function sendGA4(name, extra) {
    if (!analyticsAllowed()) return;
    try {
      var params = {
        experience:        EXPERIENCE,
        scan_id:           s.scan_id,
        device_id:         s.device_id,
        store_id:          reportedStoreId(),
        campaign_name:     s.utm_campaign || "none",
        qr_visit_id:       s.qr_visit_id,
        attribution_source: s.attribution_source,
        store_validation:  s.store_validation,
        is_new_scan_24h:   String(s.is_new_scan_24h),
        scan_start_ts:     s.scan_start_ts,
        session_elapsed_ms: Date.now() - s.scan_start_ms,
        screen_name:       s.current_screen || "unknown",
        app_version:       APP_VERSION
      };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) params[k] = extra[k];
        }
      }
      // Keep a bounded, short-lived memory queue. The Google tag owns consent
      // and network delivery; calling gtag is not an acknowledgement from GA4.
      if (pendingGA4.length >= 100) pendingGA4.shift();
      pendingGA4.push({ name: name, params: params, at: Date.now() });
      flushGA4();
      if (pendingGA4.length && !deliveryTimer) deliveryTimer = setInterval(flushGA4, 1000);
    } catch (e) {}
  }

  function flushGA4() {
    if (!analyticsAllowed()) pendingGA4 = [];
    if (validationReady && typeof window.gtag === "function" && analyticsAllowed()) {
      while (pendingGA4.length) {
        var entry = pendingGA4[0];
        if (Date.now() - entry.at > 300000) { pendingGA4.shift(); continue; }
        try { window.gtag("event", entry.name, entry.params); } catch (e) { break; }
        pendingGA4.shift();
      }
    }
    // Expire entries even if the tag never becomes available.
    while (pendingGA4.length && Date.now() - pendingGA4[0].at > 300000) pendingGA4.shift();
    if (!pendingGA4.length && deliveryTimer) { clearInterval(deliveryTimer); deliveryTimer = null; }
  }

  // ─── CLARITY HELPERS ───────────────────────────────────────────────────────

  function claritySet(key, value) {
    if (!analyticsAllowed()) return;
    if (typeof window.clarity !== "function") return;
    if (value === undefined || value === null) return;
    try { window.clarity("set", key, String(value)); } catch (e) {}
  }

  function tagClaritySession() {
    if (!validationReady || !analyticsAllowed() || typeof window.clarity !== "function") return;
    claritySet("experience",       EXPERIENCE);
    claritySet("store_id",         reportedStoreId());
    claritySet("campaign_name",    s.utm_campaign || "none");
    claritySet("store_validation", s.store_validation);
    claritySet("attribution_source", s.attribution_source);
    claritySet("qr_visit_id", s.qr_visit_id || "none");
    claritySet("qr_visit_time_ist", s.qr_visit_time_ist || "none");
    claritySet("retail_visit_type", s.retail_visit_type);
    claritySet("scan_id",          s.scan_id);
    claritySet("device_id",        s.device_id);
    claritySet("is_new_scan_24h",  String(s.is_new_scan_24h));
    claritySet("scan_start_ts",    s.scan_start_ts);
    claritySet("app_version",      APP_VERSION);
    // Backfill the latest state when Clarity arrives after early app events.
    claritySet("current_screen_name", s.current_screen || "unknown");
    claritySet("screens_reached", s.screens_reached.join(","));
    claritySet("demo_modes_tried_count", String(s.modes_tried.length));
    claritySet("demo_modes_selected_count", String(s.user_selected_modes.length));
    claritySet("tracks_played_count", String(s.plays_in_scan));
    claritySet("song_played", String(s.song_played));
    claritySet("player_reached", String(s.player_reached));
    s.clarity_ready = true;
  }

  function loadClarityFallback() {
    if (!analyticsAllowed()) return;
    // Only loads if Clarity never arrived via content_for_header
    if (typeof window.clarity === "function") return;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      if (y && y.parentNode) y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_PROJECT);
  }

  function initClarity() {
    if (!analyticsAllowed()) return;
    if (typeof window.clarity === "function") {
      tagClaritySession();
    } else {
      // Clarity loads async — retry, then fall back to manual load
      window.setTimeout(function () {
        if (typeof window.clarity === "function") {
          tagClaritySession();
        } else {
          loadClarityFallback();
          window.setTimeout(tagClaritySession, CLARITY_RETRY_MS);
        }
      }, CLARITY_RETRY_MS);
    }
  }

  // ─── VIRTUAL URL (for per-screen Clarity heatmaps) ─────────────────────────
  // Pushes ?screen=xxx into the URL so Clarity creates a separate heatmap
  // for each screen. Uses replaceState (no browser history entry added).

  function setVirtualScreenUrl(screenName) {
    try {
      if (typeof history !== "undefined" && history.replaceState) {
        var params = new URLSearchParams(window.location.search);
        if (screenName) params.set("screen", screenName);
        var searchString = params.toString();
        history.replaceState(history.state, "", window.location.pathname + (searchString ? "?" + searchString : "") + (window.location.hash || ""));
      }
    } catch (e) {}
  }

  // ─── SCREEN TRACKING ───────────────────────────────────────────────────────

  function onScreenView(event) {
    var d           = (event && event.detail) || {};
    var screenName  = d.screen_name || "unknown";
    var prevScreen  = d.previous_screen_name || s.current_screen || "";
    var now         = Date.now();

    // Fire screen_exit for whatever screen we're leaving
    if (s.current_screen && s.screen_enter_ms) {
      sendGA4("retail_screen_exit", {
        screen_name:      s.current_screen,
        screen_time_ms:   now - s.screen_enter_ms,
        next_screen_name: screenName,
        exit_reason:      "next_screen"
      });
    }

    // Update state
    s.current_screen  = screenName;
    s.screen_enter_ms = now;
    if (s.screens_reached.indexOf(screenName) === -1) {
      s.screens_reached.push(screenName);
    }

    // Send screen_view
    sendGA4("retail_screen_view", {
      screen_name:          screenName,
      previous_screen_name: prevScreen
    });

    // Virtual URL so Clarity builds a separate heatmap per screen
    setVirtualScreenUrl(screenName);

    // Clarity tags
    claritySet("current_screen_name", screenName);
    claritySet("screens_reached",     s.screens_reached.join(","));

    if (screenName === "player") {
      s.player_reached = true;
      claritySet("player_reached", "true");
    }

    // Reset scroll milestones for this screen
    if (!s.scroll_fired[screenName]) {
      s.scroll_fired[screenName] = {};
    }
  }

  // ─── CONNECT CTA ───────────────────────────────────────────────────────────

  function onConnectCta(event) {
    var d = (event && event.detail) || {};
    sendGA4("retail_connect_cta_click", {
      cta_id:     d.cta_id || "connect_continue",
      screen_name: "connect"
    });
  }

  // ─── DEMO MODE ─────────────────────────────────────────────────────────────

  function onDemoModeSelect(event) {
    var d      = (event && event.detail) || {};
    var modeId = d.demo_mode_id   || "";
    var modeName = d.demo_mode_name || "";
    var prevId = s.current_mode_id;
    var now    = Date.now();
    var selectionType = d.selection_type === "user" || d.selection_type === "automatic" ? d.selection_type : "unknown";

    // Close out previous mode — fire dwell + abandon if no play
    if (prevId && s.mode_enter_ms) {
      var dwellMs = now - s.mode_enter_ms;
      sendGA4("retail_demo_mode_dwell", {
        demo_mode_id:         prevId,
        demo_mode_name:       s.current_mode_name || "",
        demo_mode_dwell_ms:   dwellMs,
        mode_had_song_play:   s.mode_had_play,
        mode_track_play_count: s.mode_play_count,
        mode_exit_reason:     "mode_switch"
      });
      if (!s.mode_had_play) {
        sendGA4("retail_demo_mode_abandon", {
          demo_mode_id:       prevId,
          demo_mode_dwell_ms: dwellMs,
          abandon_reason:     "mode_switch"
        });
      }
    }

    // Sequence & first-mode flag
    s.mode_sequence += 1;
    var isFirst = s.mode_sequence === 1;

    sendGA4("retail_demo_mode_select", {
      demo_mode_id:                  modeId,
      demo_mode_name:                modeName,
      previous_demo_mode_id:         prevId || "",
      demo_mode_sequence_number:     s.mode_sequence,
      is_first_demo_mode:            isFirst,
      selection_type:                selectionType,
      previous_mode_had_song_play:   s.mode_had_play,
      previous_mode_play_duration_ms: (prevId && s.mode_enter_ms) ? now - s.mode_enter_ms : 0
    });

    // Update state
    s.current_mode_id   = modeId;
    s.current_mode_name = modeName;
    s.mode_enter_ms     = now;
    s.mode_had_play     = false;
    s.mode_play_count   = 0;
    s.current_playback_id = "";
    s.playback_state = "idle";

    if (s.modes_tried.indexOf(modeId) === -1) s.modes_tried.push(modeId);
    if (selectionType === "user" && s.user_selected_modes.indexOf(modeId) === -1) s.user_selected_modes.push(modeId);

    if (!s.first_mode_id) {
      s.first_mode_id = modeId;
      claritySet("first_demo_mode_id", modeId);
    }
    claritySet("last_demo_mode_id",    modeId);
    claritySet("demo_modes_tried_count", String(s.modes_tried.length));
    claritySet("demo_modes_selected_count", String(s.user_selected_modes.length));
  }

  // ─── TRACK EVENTS ──────────────────────────────────────────────────────────

  function onTrackPlay(event) {
    var d       = (event && event.detail) || {};
    var trackId = d.track_id   || "";
    var now     = Date.now();
    if (!trackId) return;
    var playbackId = d.playback_id || "";
    var samePlayback = s.current_track_id === trackId && s.current_playback_id === playbackId;
    if (samePlayback && s.playback_state !== "completed" && s.playback_state !== "skipped" && s.playback_state !== "idle") {
      var kind = d.playback_type || (s.playback_state === "paused" ? "resume" : "duplicate");
      if (kind === "start" || kind === "duplicate") return;
      if (kind === "resume" || kind === "rebuffer" || kind === "seek") {
        s.playback_state = "playing";
        s.track_play_start_ms = now;
        sendGA4("retail_track_resume", {
          track_id: trackId,
          demo_mode_id: d.demo_mode_id || s.current_mode_id || "",
          playback_type: kind,
          position_seconds: d.position_seconds || 0
        });
        return;
      }
    }

    if (!s.tracks_played[trackId]) s.tracks_played[trackId] = 0;
    s.tracks_played[trackId]++;
    s.plays_in_scan++;

    var isReplay = s.tracks_played[trackId] > 1;
    var isFirst  = s.plays_in_scan === 1;

    // Mode-level
    s.mode_had_play  = true;
    s.mode_play_count++;

    // Session-level
    s.current_track_id    = trackId;
    s.current_playback_id = playbackId;
    s.playback_state = "playing";
    s.track_play_start_ms = now;

    if (!s.first_track_id) {
      s.first_track_id = trackId;
      claritySet("first_track_id", trackId);
    }
    s.song_played = true;
    claritySet("song_played",       "true");
    claritySet("tracks_played_count", String(s.plays_in_scan));

    // Replay event
    if (isReplay) {
      sendGA4("retail_track_replay", {
        track_id:            trackId,
        demo_mode_id:        d.demo_mode_id || s.current_mode_id || "",
        replay_count_in_scan: s.tracks_played[trackId]
      });
    }

    sendGA4("retail_track_play", {
      track_id:             trackId,
      track_title:          d.track_title     || "",
      demo_mode_id:         d.demo_mode_id    || s.current_mode_id  || "",
      demo_mode_name:       d.demo_mode_name  || s.current_mode_name || "",
      play_count_in_scan:   s.plays_in_scan,
      is_first_play_in_scan: isFirst,
      is_replay:            isReplay,
      playback_type:        "start",
      time_to_first_play_ms: isFirst ? now - s.scan_start_ms : 0
    });
  }

  function onTrackPause(event) {
    var d   = (event && event.detail) || {};
    var now = Date.now();
    sendGA4("retail_track_pause", {
      track_id:         d.track_id       || s.current_track_id || "",
      demo_mode_id:     d.demo_mode_id   || s.current_mode_id  || "",
      position_seconds: d.position_seconds || 0,
      position_percent: d.position_percent || 0,
      play_duration_ms: s.track_play_start_ms ? now - s.track_play_start_ms : 0
    });
    s.track_play_start_ms = null;
    s.playback_state = "paused";
  }

  function onTrackComplete(event) {
    var d   = (event && event.detail) || {};
    var now = Date.now();
    sendGA4("retail_track_complete", {
      track_id:              d.track_id      || s.current_track_id || "",
      demo_mode_id:          d.demo_mode_id  || s.current_mode_id  || "",
      track_duration_seconds: d.track_duration_seconds || 0,
      play_duration_ms:       s.track_play_start_ms ? now - s.track_play_start_ms : 0
    });
    s.track_play_start_ms = null;
    s.playback_state = "completed";
  }

  function onTrackSkip(event) {
    var d   = (event && event.detail) || {};
    var now = Date.now();
    sendGA4("retail_track_skip", {
      track_id:           d.track_id          || s.current_track_id || "",
      demo_mode_id:       d.demo_mode_id      || s.current_mode_id  || "",
      skipped_at_percent: d.skipped_at_percent || 0,
      play_duration_ms:   s.track_play_start_ms ? now - s.track_play_start_ms : 0,
      skip_reason:        d.skip_reason        || "track_change"
    });
    s.track_play_start_ms = null;
    s.playback_state = "skipped";
  }

  function onRetailError(event) {
    var d = (event && event.detail) || {};
    sendGA4("retail_error", {
      error_type:          d.error_type          || "js_error",
      error_message_short: d.error_message_short || "",
      demo_mode_id:        d.demo_mode_id        || s.current_mode_id  || "",
      track_id:            d.track_id            || s.current_track_id || ""
    });
  }

  // ─── SCROLL DEPTH ──────────────────────────────────────────────────────────

  function checkScrollDepth() {
    var scrollTop = window.pageYOffset
      || (document.documentElement && document.documentElement.scrollTop)
      || 0;
    var docH = Math.max(
      (document.documentElement && document.documentElement.scrollHeight) || 0,
      (document.body && document.body.scrollHeight) || 0
    ) - window.innerHeight;

    if (docH <= 0) return;

    var pct   = Math.min(100, Math.round((scrollTop / docH) * 100));
    var screen = s.current_screen || "unknown";

    if (!s.scroll_fired[screen]) s.scroll_fired[screen] = {};

    SCROLL_MILESTONES.forEach(function (m) {
      if (pct >= m && !s.scroll_fired[screen][m]) {
        s.scroll_fired[screen][m] = true;
        if (m > s.max_scroll) s.max_scroll = m;
        sendGA4("retail_scroll_depth", {
          screen_name:   screen,
          depth_percent: m
        });
      }
    });
  }

  function setupScrollTracking() {
    var ticking = false;
    window.addEventListener("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          if (analyticsAllowed()) checkScrollDepth();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ─── SESSION SUMMARY & EXIT ────────────────────────────────────────────────

  function summaryParams() {
    return {
      session_duration_ms:    Date.now() - s.scan_start_ms,
      current_screen_name:    s.current_screen || "unknown",
      max_scroll_depth:       s.max_scroll,
      screens_reached:        s.screens_reached.join(","),
      demo_modes_tried_count: s.modes_tried.length,
      tracks_played_count:    s.plays_in_scan,
      song_played:            String(s.song_played),
      player_reached:         String(s.player_reached),
      last_demo_mode_id:      s.current_mode_id   || "",
      last_track_id:          s.current_track_id  || ""
    };
  }

  function sendSummary() {
    sendGA4("retail_session_summary", summaryParams());
    claritySet("last_screen_name",       s.current_screen || "");
    claritySet("demo_modes_tried_count", String(s.modes_tried.length));
    claritySet("tracks_played_count",    String(s.plays_in_scan));
    claritySet("max_scroll_depth",       String(s.max_scroll));
  }

  function setupSessionSummary() {
    s.summary_timer = setInterval(sendSummary, SUMMARY_INTERVAL);
  }

  function setupExitTracking() {
    var exitSent = false;
    window.addEventListener("pagehide", function () {
      if (s.summary_timer) clearInterval(s.summary_timer);
      s.summary_timer = null;
      if (exitSent || !analyticsAllowed()) return;
      exitSent = true;

      var now = Date.now();

      // Close out current demo mode
      if (s.current_mode_id && s.mode_enter_ms) {
        var dwellMs = now - s.mode_enter_ms;
        sendGA4("retail_demo_mode_dwell", {
          demo_mode_id:          s.current_mode_id,
          demo_mode_name:        s.current_mode_name || "",
          demo_mode_dwell_ms:    dwellMs,
          mode_had_song_play:    s.mode_had_play,
          mode_track_play_count: s.mode_play_count,
          mode_exit_reason:      "session_end"
        });
        if (!s.mode_had_play) {
          sendGA4("retail_demo_mode_abandon", {
            demo_mode_id:       s.current_mode_id,
            demo_mode_dwell_ms: dwellMs,
            abandon_reason:     "page_exit"
          });
        }
      }

      // Close out current screen
      if (s.current_screen && s.screen_enter_ms) {
        sendGA4("retail_screen_exit", {
          screen_name:    s.current_screen,
          screen_time_ms: now - s.screen_enter_ms,
          exit_reason:    "pagehide"
        });
      }

      // Final session_end
      var sp = summaryParams();
      sp.exit_screen = s.current_screen || "unknown";
      sp.exit_reason = "pagehide";
      sendGA4("retail_session_end", sp);
    });

    // Periodic backup when tab goes hidden (mobile home button etc.)
    document.addEventListener("visibilitychange", function () {
      if (document.hidden && analyticsAllowed()) sendSummary();
    });
    window.addEventListener("pageshow", function (event) {
      if (!event.persisted) return;
      exitSent = false;
      s.screen_enter_ms = Date.now();
      if (s.current_mode_id) s.mode_enter_ms = Date.now();
      if (!s.summary_timer) setupSessionSummary();
    });
  }

  // ─── BIND APP EVENTS ───────────────────────────────────────────────────────

  function bindListeners() {
    var listeners = {
      "retail:screen_view": onScreenView,
      "retail:connect_cta_click": onConnectCta,
      "retail:demo_mode_select": onDemoModeSelect,
      "retail:track_play": onTrackPlay,
      "retail:track_pause": onTrackPause,
      "retail:track_complete": onTrackComplete,
      "retail:track_skip": onTrackSkip,
      "retail:error": onRetailError
    };
    Object.keys(listeners).forEach(function (name) {
      window.addEventListener(name, function (event) { if (analyticsAllowed()) listeners[name](event); });
    });
  }

  // ─── INIT ──────────────────────────────────────────────────────────────────

  function startTracking() {
    if (started || !analyticsAllowed()) return;
    started = true;
    try {
      s.scan_start_ms = Date.now();
      initIdentity();
      initAttribution();
      validateStore();
      initClarity();

      sendGA4("retail_scan_start", {
        landing_url:      window.location.href,
        referrer:         document.referrer || "",
        store_id:         reportedStoreId(),
        campaign_name:    s.utm_campaign,
        utm_source:       s.utm_source,
        utm_medium:       s.utm_medium,
        utm_content:      s.utm_content,
        device_type:      window.innerWidth <= 820 ? "mobile" : "desktop",
        screen_width:     window.screen ? window.screen.width  : window.innerWidth,
        screen_height:    window.screen ? window.screen.height : window.innerHeight,
        is_new_scan_24h:  String(s.is_new_scan_24h),
        retail_visit_type: s.retail_visit_type,
        is_new_qr_visit: String(s.is_new_qr_visit),
        attribution_age_days: s.attribution_age_days
      });

      if (s.is_new_qr_visit) sendGA4("retail_qr_visit", {
        qr_visit_time_ist: s.qr_visit_time_ist,
        retail_visit_type: s.retail_visit_type,
        reported_store_id: s.store_id,
        utm_source: s.utm_source,
        utm_medium: s.utm_medium,
        utm_content: s.utm_content,
        utm_term: s.utm_term
      });

      bindListeners();
      setupScrollTracking();
      setupSessionSummary();
      setupExitTracking();
    } catch (err) {
      // Analytics must never break the main app — fail silently
    }
  }

  function init() {
    document.addEventListener("visitorConsentCollected", function () {
      if (!analyticsAllowed()) { pendingGA4 = []; flushGA4(); return; }
      if (!started) startTracking();
      else { flushGA4(); initClarity(); }
    });
    startTracking();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
